import React, { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { fetchCallLogs, fetchUserCallLogs } from '../../Services/contacts';

import TopBar from '../../Components/TopBar/TopBar';
import commonStyle from '../common.module.css';
import Loading from '../../Components/Loading/Loading';
import {
  booleanObject,
  CALLLOG_COLUMNS,
  datesField,
} from '../../Values/tables';
import { getDateString, searchCallLogs,getDateStringUpdated } from '../../Values/utils';
import CustomTable from '../../Components/CustomTable/CustomTable';
import axios from 'axios';
import moment from 'moment';
import {
  setFilterObject,
  setRefreshCallLogs,
  showSnackbarAction,
  clearAllFilters,
  setCurrentRoute
} from '../../Redux/actions';
import ApiCustomTable from '../../Components/CustomTable/ApiCustomTable';
import ApiTopBar from '../../Components/TopBar/ApiTopBar';
import { calllogFilterValues, url } from '../../Values/constants';
import styles from '../Analytics/Analytics.module.css';
import {themeColors} from "../../Components/theme";
import PopUpBox from "../AuditLogs/PopUpBox";
import axiosHandler from '../../Services/axiosHandler';
import { googleAnalytics } from '../../Services/users';
import { useLocation } from 'react-router-dom';
import HtmlBanner from "../../bannerManagement/baneerComp";

type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  filterObject: any;
  filterSort: any;
  refreshCallLogs: boolean;
  searchString: string;
  theme: any;
  authToken:any;
};

let isFinished = false;

const CallLogsPanel: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  filterObject,
  searchString,
  filterSort,
  refreshCallLogs,
  theme,
  authToken
}) => {
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [callList, setCallList] = useState<any[]>();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [searchedItem, setsearchedItem] = useState('');
  const [columnModal, setColumnModal] = useState(false);
  const [originalData, setOriginalData] = useState<any[] | undefined>(
    undefined
  );
  const [contactsMap, setcontactsMap] = useState<any>(undefined);

  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allCallLogs, setAllCallLogs] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>({});
  const [filterCount, setFilterCount] = useState<any>({});
  const [showImportModal, setShowImportModal] = useState(false);

  const dispatcher = useDispatch();
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [userEmail, setUserEmail] = useState<any>(undefined);
  const [showColumns, setShowColumns] = useState<any>(null);
  const [isGACalled, setIsGACalled] = useState<any>(false);

    const [cRoute,setCRoute]=useState("")
  
        const location = useLocation();
  
    useEffect(() => {
      dispatcher(setCurrentRoute(location.pathname))
      setCRoute(location.pathname)
    }, [location]);
  
  // useEffect(()=>{
  //   dispatcher(clearAllFilters({}));
  // },[])
  useEffect(() => {
    if (organizationUsers) {
      // To store info of user
      let emailInfo: { [key: string]: string } = {};
      organizationUsers.forEach((user: any) => {
        emailInfo[user.user_email]=user;
      });
      setUserEmail(emailInfo)
    }
  }, [organizationUsers]);

  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    } else {
      setLoad(true);
      const filters: { [key: string]: any[] } = {};
      let feild;
      filters["transfer_status"] = [false];
      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          if (item === "is_button_called" || item === "transfer_status" || item === "associate_status" || item === "source_status") {
            if (filterObject[item].length === 2) {
              filters[item] = [true, false];
            } else {
              filters[item] =
                filterObject[item][0] === "True" ? [true] : [false];
            }
          } else {
            if (item === "contact_no") {
            } else filters[item] = filterObject[item];
          }
        }
      });

      if (searchString === '') {
        feild = 'contact_no';
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = 'contact_no';
        } else {
          feild = 'customer_name';
        }
      }
      let records = localPageSize ? localPageSize : pageSize;
      const apiData = {
        uid: user.uid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: '-1' }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        filter: filters
      };
      if(filters==null || filters == undefined ){
        return
      }
      else{
        setFilterCount(filters);
      }

      try {
//         axios.defaults.headers.common['x-access-token'] =
// authToken
        const res = await axiosHandler.post(url + '/callLogs/search', apiData);
 
        let data: any[] = res.data;
        if (data.length < records && paginate) {
          isFinished = true;
          setLastPage(page);
        }

        data.forEach((task) => {
          task.contactId = task.leadId;
          task.reporting_to = userMap[task.contact_owner_email];
          // if (userEmail && userEmail[task.contact_owner_email]) {
              let info=userEmail[task.contact_owner_email];
            if(info){
              task.employee_id=info.employee_id?info.employee_id:"";
                if(info.user_first_name || info.user_last_name){
                  task.employee_name=info.user_first_name+" "+info.user_last_name;
                }
            }
            // }
          delete task['Id'];
          Object.keys(task).forEach((key) => {
            if (datesField.includes(key) && task[key] !== '') {
              if (task[key] !== null) {
                task[key] = moment(task[key]);
              } else {
                task[key] = '';
              }
            }
          });
        });

        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
        } else {
          setFilterData(data);
        }
        setLoad(false);
      } catch(error) {
        // setFilterData([]);
        setLoad(false);
        // dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
      }
    }
  };

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (userMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if(authToken){
      callApi(false, pageSize, 1);
    }
  }, [user, filterObject, filterSort, searchString, allCallLogs,authToken,userEmail]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if(authToken){
          callApi(false, pageSize);
        }
      } else {
        if(authToken){
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken,userEmail]);

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      setFilterData([]);
      return;
    }
    if(authToken){
      callCountApi();
    }
  }, [refreshCallLogs, user.uid, filterCount,authToken]);

  const callCountApi = async () => {
//     axios.defaults.headers.common['x-access-token'] =
// authToken
if (Object.keys(filterCount).length === 0) {
  // console.log('The object is empty.');
} else {
  // console.log('The object is not empty.');
  const res = await axiosHandler.post(url + '/callLogs/callLogCount', {
    uid: user.uid,
    leadFilter: filterCount
  });
  setTotalCounts(res.data.total);
}

    // const res = await axios.post(url + '/callLogs/callLogCount', {
    //   uid: user.uid,
    //   leadFilter: filterCount
    // });

    // console.log(res,"GRGEGERGVVRG")
    // console.log(filterCount,"GRGEGERGVVRG")
    // setTotalCounts(res.data.total);
  };



  useEffect(() => {
    if (refreshCallLogs === true && authToken) {
      callApi();
      getCallLogsFilter();
      dispatcher(setRefreshCallLogs(false));
    }
  }, [refreshCallLogs,authToken,userEmail]);
  // useEffect(()=>{
  //   const storedValue = localStorage.getItem('calllogShowFilterValues');
  //   setShowColumns(storedValue);
  //     getCallLogsFilter();
  // },[localStorage.getItem('calllogShowFilterValues'),showColumns])

  const getCallLogsFilter = async () => {
//     axios.defaults.headers.common['x-access-token'] =
// authToken
    const res = await axiosHandler.post(url + '/callLogs/filterValues', {
      uid: user.uid,
      showColumns:showColumns === null?calllogFilterValues:JSON.parse(showColumns)
    });
    const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
      organization_id: user.organization_id,
      uid: user.uid,
      });
    //  console.log(userdetail.data.data)
    if (res.data[0]) {
      dispatcher(setFilterObject({ ...res.data[0], ...booleanObject,'employee_name':userdetail.data.data.Employee_Name,'employee_id':userdetail.data.data.Employee_id,}));
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    const storedValue = localStorage.getItem('calllogShowFilterValues');
    setShowColumns(storedValue);
    if (user === undefined || user.uid === undefined) {
      return;
    }
    if(authToken){
      getCallLogsFilter();
    }
  }, [user,authToken,userEmail,localStorage.getItem('calllogShowFilterValues'),showColumns]);

  const exportFile = () => {
    let data: any[] = [];
    if (selectedRowsData.length === 0) {
    } else {
      selectedRowsData.forEach((item) => {
        data.push({
          // 'Lead Id': item.leadId,
          'Customer Name': item.customer_name,
          'Contact Number': item.contact_no,
          'Lead Stage': item.stage,
          Duration: item.duration,
          'Created On': getDateStringUpdated(item.created_at),
          Project: item.project,
          Location: item.location,
          'Lead Source': item.source,
          "Lead Assignee": item.employee_name,
          'Lead Assignee Email': item.contact_owner_email,
          Budget: item.budget,
          'Inventory Type': item.inventory_type,
          'Transfer Status': item.transfer_status,
          // Status: item.status,
          'Created By': item.created_by,
          "Employee ID":item.employee_id,
          'Lead State': item.state,
          'Call Recording': item.call_recording_url,
        });
      });
    }

    return data;
  };

  const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Call_Log_Screen',user)
      }
    }
  },[user])

        const [isHardRefresh, setIsHardRefresh] = useState(false);
  
  useEffect(() => {
    const navEntries:any = performance.getEntriesByType('navigation');
    if (navEntries.length > 0 && navEntries[0].type === 'reload') {
      setIsHardRefresh(true);
    }
  }, []);
  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: "0px", ...containerStyles }}>
      {filterData === undefined && <Loading />}
      
          {cRoute&& isHardRefresh&&( <div className={styles.PbContainer}>
        <HtmlBanner   user={user} route={cRoute} bannerType={"pageBanner"}/>
      </div>)}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <ApiTopBar
            history={history}
            title={'Add Call Logs'}
            path={'/addContacts'}
            onClick={() => {
              setShowImportModal(true);
            }}
            onChange={(val) => setsearchedItem(val)}
            filterText={'Status'}
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            showStatusBox={false}
            searchedString={searchString}
            onExport={exportFile}
            selectedRows={selectedRows}
            setAuditLog={setAuditLog}
            isOtpVerified={isOtpVerified}
            panel = "call logs"
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px",...containerStyles }}>
        
          <ApiCustomTable
            tableColumns={CALLLOG_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="CallLogs"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setPage={(val) => setPage(val)}
            setPageSize={(val) => setPageSize(val)}
            callApi={callApi}
            pageSize={pageSize}
            page={page}
            isFinished={isFinished}
            totalCount={totalCounts}
            lastPage={lastPage}
          />
           {auditLog && (
              <PopUpBox
              open={auditLog}
              close={() => setAuditLog(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "call logs"
              />)}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    // filterObject: state.filter,
    // filterSort: state.filterSort,
    filterObject: state.callLogFilter,
    filterSort: state.callLogfilterSort,
    searchString: state.searchItem.callLogsSearchString,
    refreshCallLogs: state.refresh.refreshCallLogs,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
  };
};
export default connect(mapStateToProps)(CallLogsPanel);
